import React from 'react';
import { Link } from 'react-router-dom';

const SimpleHostingCta = () => (
  <div className="bg-gray-50 py-12">
    <div className="text-center max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold text-blue-900 mb-4">Need something simpler?</h2>
      <p className="text-gray-700 mb-6">Get popular open source services fully managed by us—no server babysitting required.</p>
      <Link to="/apps" className="text-white bg-blue-900 hover:bg-blue-800 px-6 py-3 rounded-lg shadow">
        Explore Managed Apps
      </Link>
    </div>
  </div>
);

export default SimpleHostingCta;
